<template>
  <page>
    <head-nav :title="$t('language.support_details')">
      <icon-button-hamburger slot="left"></icon-button-hamburger>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

    <scroll-page :pull-reload="false">

    
<!--
    <page-padding>
      
    
    <div class="center-text"><img v-if="appSettings.school_app_logo" :src="appSettings.school_app_logo"></div>

    <div class="center-text"><b>{{appSettings.school_app_namefield1}}</b></div>
    <div class="center-text">{{appSettings.school_app_namefield2}}</div>
    <div class="center-text">{{appSettings.school_app_address}}</div>
    <div class="center-text">{{appSettings.school_app_contact}}</div>
    <div class="center-text">{{appSettings.school_app_city}}</div>
    <div class="center-text">{{appSettings.school_app_website}}</div>
    <div class="center-text"><a :href="'mailto:'+appSettings.school_app_email">{{appSettings.school_app_email}}</a></div>
    <div class="center-text">{{appSettings.school_app_phone}}</div>
    
    </page-padding>
-->

    <page-padding>
      
      <text-block>
        {{$t('language.suggestions')}}
      </text-block>
      <br>
      <ui-input :readonly="true" title="language.provide_name" type="text" v-bind:val="name" @input="(v)=>{name = v}"></ui-input>
      <ui-input :readonly="true" title="language.provide_email" type="text" v-bind:val="email" @input="(v)=>{email = v}"></ui-input>
      <ui-input title="language.provide_tel" type="text" v-bind:val="phone" @input="(v)=>{phone = v}"></ui-input>
      <ui-textarea title="language.message" v-bind:val="message" @input="(v)=>{message = v}"></ui-textarea>
      <button-activate :active="buttonActive" v-on:click.native="sendForm()" title="language.send"></button-activate>
    </page-padding>

     </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../components/PagePadding.vue';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import ScrollPage from '../components/ScrollPage.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import UiInput from '../components/UiInput.vue';
import UiTextarea from '../components/UiTextarea.vue';
import TextBlock from '../components/TextBlock.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import { SETTINGS } from '../SETTINGS.js';
import Vue from 'vue';


export default {
  name: 'contact-page',
  data:function(){
    return {
      name:"",
      email:"",
      message:"",
      phone:"",
      buttonActive:true,
      app_version:SETTINGS.version,
      school:undefined,
    }
  },
  methods:{
    isFormComplete(){
     
      if(this.name===""){
          modalService.createAlert(i18n.t('language.form_incomplete_name'))
        return false;
      }
      if(this.email===""){
          modalService.createAlert(i18n.t('language.form_incomplete_email'))
        return false;
      }
      
      if(this.message===""){
          modalService.createAlert(i18n.t('language.form_incomplete_message'))
        return false;
      }

      return true
    },
    sendForm(){
      if(!this.isFormComplete()){
        return;
      }

      this.buttonActive=false;
      // get active school
      var school = this.user_schools.find(school => school.active === 1);



      // depending on cordova device plugin..
      if(!window.device){
        window.device={
          platform:"test",
          model:"test",
          version:"test",
        }
      }
     

      var payload={
        url:school.url,
        phno:this.phone,
        name:this.name,
        message:this.message,
        email_id:this.email,
        device_platform: window.device.platform,
        device_model: window. device.model,
        device_uuid: window.device.uuid,
        device_version: window.device.version,
        app_version:this.app_version,
        language:this.user_stored.language,
        user_level:this.appSettings.user_level,
      }


      this.$store.dispatch('send_contact_form',payload).then(()=>{
        this.buttonActive=true;
        this.phone="";
        this.name="";
        this.message="";
        this.email="";

        Vue.$toaster.toast(i18n.t("language.support_sent"))
        
          
      })
    },
  },
  computed:{
     ...mapState([
       'appSettings','user_schools','user_stored',
       ]),
  },
  components:{
    ScrollPage,
    PagePadding,
    Page,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    ButtonActivate,
    UiInput,
    UiTextarea,
    TextBlock,
  },
  created(){
  },
  mounted(){
   this.school=this.user_schools.find(school => school.active === 1);
   
   this.email=this.school.username;
   this.name=this.appSettings.fullname;

  },
  beforeDestroy(){
  }
  
  
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center-text{
  text-align: center;
}
</style>